__webpack_require__.p = "/YGOSmallWorldMap/";